import { fetcher } from '@dashboard/services/request';

export default async function getStripePaymentMethodConfigurations({ sellerId, token }) {
  const response = await fetcher(
    `/sellers/${sellerId}/stripe/payment-method-configurations`,
    token,
  );
  return response?.paymentMethodConfigurations ?? [];
}
